/** Roles que pueden activar o desactivar Zoom en un curso. */
export const ZOOM_TOGGLE_TYPE_USERS = [
    'director',
    'control escolar',
    'administrativo',
];

export const canToggleCourseZoom = (typeUser) => (
    ZOOM_TOGGLE_TYPE_USERS.includes(typeUser)
);

/** Solo `true` explícito cuenta; ausente / null / false = sin Zoom. */
export const isCourseZoomEnabled = (courseOrFlag) => {
    if (typeof courseOrFlag === 'boolean') return courseOrFlag === true;
    return courseOrFlag?.zoomEnabled === true;
};
